var __TEMP__ = require('./_createMathOperation.js');var createMathOperation = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * Subtract two numbers.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {number} minuend The first number in a subtraction.
 * @param {number} subtrahend The second number in a subtraction.
 * @returns {number} Returns the difference.
 * @example
 *
 * _.subtract(6, 4);
 * // => 2
 */
var subtract = createMathOperation(function(minuend, subtrahend) {
  return minuend - subtrahend;
}, 0);

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = subtract;
